<template>
  <div class="home xlbox" :style="{ height: pageHeight + 'px' }">
    <div class="tj">
      <h3 style="display:flex"><span style="flex:1">{{mlName}}</span><em style="width:16px" @click="Collection(collect)"><van-icon :name="collect? src1 : src2"/></em></h3>
      <div style="height:auto;margin-bottom: 8px;">
        <van-image width="100%" height="100%" fit="contain" :src="xlsrcImg" >
          <template v-slot:loading>
            <van-loading type="spinner" size="20" />
          </template>
        </van-image>
      </div>
      <!-- <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh"> -->
          <!-- <p>刷新次数: {{ count }}</p> -->
          <div>
            <div class="item xltj">
              <span>今日运行状态<em v-show="this.list.length==0">截至当前</em><em v-show="this.list.length>0">{{this.list.acciTime}}</em></span>
              <p v-show="this.list.length==0">
                <van-icon size="28px" :name="require('../assets/zc@3x.png')" style="vertical-align: middle;"/>
                运行良好，未发生跳闸停电事件
              </p>

              <!-- <p v-show="this.list.length>0">
                <van-icon size="28px" :name="require('../assets/yc@3x.png')" style="vertical-align: middle;"/>
                {{this.list.fnote}}
              </p> -->

              <van-steps direction="vertical" :active="10" active-color="#C9C9C9" v-show="this.list.length>0">
                <van-step  v-for="(Item, index) in list" :key="index">
                  <!-- <h3>xxx线路名称名称2-速断故障</h3> -->
                  <h3>{{Item.acciTime}}</h3>
                  <!-- <van-button color="#F27A2B" plain size="mini">区间定位</van-button> -->
                  <p>
                    {{Item.fnote}}
                    <!-- 2021/1/22 08:00:25xxxxx线路名称发生速断故障，故障区段在南湖支线#2与南湖支线#14之间。 -->
                  </p>
                </van-step>
                <!-- <van-step>
                  <van-button color="#0BA57B" plain size="mini">精确定位</van-button>
                  <p>
                    2021/1/22 08:00:25xxxxx线路名称发生速断故障，故障区段在南湖支线#2。
                  </p>
                </van-step> -->
              </van-steps>
            </div>

            <div class="item xltj zdtj">
              <h3>安装设备</h3>
              <div class="chart" id="chart1"></div>
              <p style="color:#A2A1A0;font-size:12px;">架空和电缆：精确故障定位设备</p>
            </div>

            <div class="item xltj zdtj">
              <span>线路历史故障<em class="see" @click="toMlineHistoryDiares">查看</em></span>
              <div class="chart" id="chart2"></div>
            </div>

            <div class="item xltj" v-if="contactShow">
              <span>线路联系人<em class="see" @click="toMlineContact">查看</em></span>
              <van-row type="flex"  align="center" v-for="(item,index) in Contactlist" :key="index">
                <van-col  span="4" >
                  <van-image
                    round
                    width="50px"
                    height="50px"
                    :src="imgSrc"
                  />
                </van-col>
                <van-col span="10">
                  <p class="user">
                    <span>{{item.cpname}}</span>
                    <!-- <span>联系人id{{item.conperId}}</span> -->
                    <!-- <van-button color="#0B7DEC" size="mini" round type="info">系统维护员</van-button> -->
                  </p>
                  <van-button color="#0B7DEC" size="mini" round type="info">系统维护员</van-button>
                </van-col>
                <van-col  justify="end"><span class="tel">手机号：{{item.phoneNum}}</span></van-col>
              </van-row>
            </div>

          </div>
        <!-- </van-pull-refresh>
      </van-list> -->
    </div>
  </div>
</template>

<script>
import myMixinxlDetials from '@/utils/minxinsxlDetials.js'
import Vue from 'vue'
import { Col, Row, Button, NavBar, List, PullRefresh, Icon, Image as VanImage, Loading, Toast, Step, Steps } from 'vant'

// import axios from 'axios' // 引入axios进行前后端交互
Vue.use(Col, Row, Button, NavBar, List, PullRefresh, Icon, VanImage, Loading, Toast, Step, Steps)

export default {
  name: 'xlDetialsPage',
  mixins: [myMixinxlDetials], // 引入混入
  components: {
    [Col.name]: Col,
    [Row.name]: Row,
    [Button.name]: Button,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Icon.name]: Icon,
    [VanImage.name]: VanImage,
    [Loading.name]: Loading,
    [Toast.name]: Toast,
    [Step.name]: Step,
    [Steps.name]: Steps

  },
  data () {
    return {
      mlineId: '',
      collect: false, // 是否收藏
      type: '', // 1：收藏 2：取消
      mlName: '', // 线路名称
      src1: require('../assets/sc-on@3x.png'),
      src2: require('../assets/sc@3x.png'),
      count: 0,
      isLoading: false,
      list: [],
      Contactlist: [],
      loading: false,
      finished: false,
      pageHeight: window.innerHeight - 56,
      imgSrc: require('../assets/tx@3x.png'),
      dtuInstallData: { }, // 安装设备返回数据
      MlineDiaresData: { }, // 线路历史故障返回数据
      contactShow:false,
      // currentPage: 1, // 当前页
      // pagesize: 2 // 每页显示条数
    }
  },
  computed: {
    xlsrcImg () {
      // console.log(this.$route.query.mlineId)
      let xlsrcImg = window.config.baseUrl+'/showMlineImg?mlineId=' + this.$route.query.mlineId// 展示线路图
      return xlsrcImg
    }
  },
  activated () {
    // console.log('activated')
    // console.log(this.$route.query.mlineId)
    this.getCollectMline()
    this.getDtuRunStatus()
    this.dtuInstall()// 安装设备
    this.getMlineDiaresByMlineId()// 线路历史故障
    if (window.config.type===0){
      this.contactShow = true
      this.getMlineContact()// 线路联系人
    }
    
  },
  created () {
    // console.log('created')
    // console.log(this.$route.query.mlineId)
    this.mlineId = this.$route.query.mlineId// 传过来的线路id
    this.getCollectMline()
    this.getDtuRunStatus()
    this.dtuInstall()// 安装设备
    this.getMlineDiaresByMlineId()// 线路历史故障
    if (window.config.type===0){
      this.contactShow = true
      this.getMlineContact()// 线路联系人
    }
  },
  mounted () {
    // console.log('mounted')
    this.mlineId = this.$route.query.mlineId// 传过来的线路id
    this.getCollectMline()
    this.getDtuRunStatus()
    this.dtuInstall()// 安装设备
    this.getMlineDiaresByMlineId()// 线路历史故障
    if (window.config.type===0){
      this.contactShow = true
      this.getMlineContact()// 线路联系人
    }
  },
  methods: {
    onClickLeft () {
      // window.history.back()
      this.$router.go(-1)// 返回上一页面
      this.$store.commit('setTransition', 'turn-on')
    },
    Collection (collect) {
      this.collect = !collect
      if (collect) {
        this.type = 2
      } else {
        this.type = 1
      }
      this.util.post('/addCollectMline', {
        mlineId: this.$route.query.mlineId,
        type: this.type// 1：收藏 2：取消
      }).then(({ data }) => {
        if (data.code === 200) {
          setTimeout(() => {
            this.util.toast(data.msg)
          }, 20)
          // this.util.toast(data.msg)
          // Toast({
          //   message: data.msg,
          //   duration: 2500
          // })
        } else {
          return Promise.reject(new Error(data.message || data.msg || '系统错误，请稍后再试。'))
        }
      })
    },
    toMlineHistoryDiares () {
      this.$router.push({
        path: '/mlineHistoryDiaresPage', query: { mlineId: this.$route.query.mlineId }// 跳转到线路历史故障页
      })
    },
    toMlineContact () {
      this.$router.push({
        path: '/mlineContactPage', query: { mlineId: this.$route.query.mlineId } // 跳转到线路联系人页
      })
    },
    getCollectMline () {
      // 线路是否收藏
      this.util.post('/getCollectMline', {
        mlineId: this.$route.query.mlineId
      }).then(({ data }) => {
        if (data.code === 200) {
          this.mlName = data.data.mlName
          if (data.data.status === 0) {
            this.collect = false
          } else {
            this.collect = true
          }
        } else {
          return Promise.reject(new Error(data.message || data.msg || '系统错误，请稍后再试。'))
        }
      })
    },
    getDtuRunStatus () {
      // 今日运行状态
      this.util.post('/getDtuRunStatus', {
        mlineId: this.$route.query.mlineId
      }).then(({ data }) => {
        if (data.code === 200) {
          this.list = data.data.list
          // console.log(this.list)
        } else {
          return Promise.reject(new Error(data.message || data.msg || '系统错误，请稍后再试。'))
        }
      })
    },
    dtuInstall () {
      // 安装设备
      this.util.post('/dtuInstall', {
        mlineId: this.$route.query.mlineId
      }).then(({ data }) => {
        if (data.code === 200) {
          this.dtuInstallData = data.data
          this.$nextTick(() => {
            this.drawLine_aa()
          })
        } else {
          return Promise.reject(new Error(data.message || data.msg || '系统错误，请稍后再试。'))
        }
      })
    },
    getMlineDiaresByMlineId () {
      // 线路历史故障
      this.util.post('/getMlineDiaresByMlineId', {
        mlineId: this.$route.query.mlineId
      }).then(({ data }) => {
        if (data.code === 200) {
          this.MlineDiaresData = data.data
          this.$nextTick(() => {
            this.drawLine_bb()
          })
        } else {
          return Promise.reject(new Error(data.message || data.msg || '系统错误，请稍后再试。'))
        }
      })
    },
    getMlineContact () {
      // 线路联系人
      this.util.post('/getMlineContact', {
        mlineId: this.$route.query.mlineId,
        currentPage: 1, // 当前页
        pagesize: 2// 每页显示条数
      }).then(({ data }) => {
        if (data.code === 200) {
          this.Contactlist = data.data.data.items
        } else {
          return Promise.reject(new Error(data.message || data.msg || '系统错误，请稍后再试。'))
        }
      })
    }

  }

}
</script>

<style scoped lang="less">
/deep/.van-nav-bar__content {
  height: 88px;
  background-color: #0b7dec;
}
/deep/.van-nav-bar__title {
  font-size: 17px;
  font-weight: bold;
  color: #fff;
}
/deep/.van-nav-bar .van-icon {
  font-size: 17px;
  color: #fff;
}
.item .van-row{
  padding: 20px 0;
  border-bottom: 1px solid #EBEBEB;
}
.item .van-row:last-child{
  border-bottom: none;
}
.home{
  margin-top: 56px;
}
.home .tj h3 {
    color: #353535;
    font-size: 16px;
    margin-bottom: 8px;
}
.home .item > span{
  border-bottom: none;
}
.van-button--round{
  font-size: 12px;
}
/deep/.van-step__title h3{
  color: #A2A1A0!important;
  font-size: 11px!important;
  margin-bottom: 3px!important;
}
/deep/.van-step__title p{
  color: #353535;
  font-size: 14px;
  word-wrap: break-word;
  word-break: break-all;
}
/deep/.van-step__circle{
  width: 9px;
  height: 9px;
  background: #C9C9C9;
}
</style>
